export const cacheImage = async (data) => {
    const promises = data.map((currentVideo) => {
        return new Promise((resolve, reject) => {
            const sizeCount = currentVideo.pictures.sizes.length;
            const pic = currentVideo.pictures.sizes[sizeCount - 1];
            const image = new Image()
            image.src = pic.link;
            image.onload = resolve()
            image.onerror = reject()
        })
    })

    await Promise.all(promises);
}